import React, { useEffect, useRef } from 'react';

interface StackBlitzEmbedProps {
  projectId: string;
  height?: string;
  openFile?: string;
  view?: 'default' | 'preview' | 'editor';
  theme?: 'light' | 'dark';
}

const StackBlitzEmbed: React.FC<StackBlitzEmbedProps> = ({
  projectId,
  height = '600px',
  openFile,
  view = 'default',
  theme = 'light',
}) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    // StackBlitz SDK integration can be added here if needed
  }, [projectId]);

  const embedUrl = React.useMemo(() => {
    const params = new URLSearchParams({
      embed: '1',
      file: openFile || '',
      view: view,
      theme: theme,
    });

    return `https://stackblitz.com/edit/${projectId}?${params.toString()}`;
  }, [projectId, openFile, view, theme]);

  return (
    <div className="stackblitz-embed-container rounded-lg overflow-hidden border border-gray-200 shadow-sm">
      <iframe
        ref={iframeRef}
        src={embedUrl}
        style={{
          width: '100%',
          height: height,
          border: 0,
          overflow: 'hidden',
        }}
        title={`StackBlitz ${projectId}`}
        allow="accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr; xr-spatial-tracking"
        sandbox="allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts"
      />
    </div>
  );
};

export default StackBlitzEmbed;

